<template>
  <div>
    <!-- Button trigger modal -->
    <button
      id="modal-btn"
      type="button"
      class="btn btn-primary d-none"
      data-toggle="modal"
      data-target="#exampleModal"
    >Launch demo modal</button>

    <!-- Modal -->
    <div
      class="modal fade"
      id="exampleModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header text-white">
            <h5 class="modal-title" id="exampleModalLabel">Error</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <i class="fa fa-times text-white" aria-hidden="true"></i>
            </button>
          </div>
          <div class="modal-body text-center mt-5">
            <i class="fa fa-times text-danger fa-10x" style="font-weight:300;" aria-hidden="true"></i>
            <p>{{ error }}</p>
            <button
              type="button"
              class="btn continue-btn float-right mt-5"
              data-dismiss="modal"
            >Close</button>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="complete != ''"
      class="alert alert-fixed alert-success alert-dismissible fade show"
      role="alert"
    >
      <strong>{{ complete }}</strong>
      <button type="button" class data-dismiss="alert" aria-label="Close" @click="complete = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="card text-left">
      <div class="card-body">
        <span class="d-none d-md-block">
          <img src="../../assets/bolt.svg" width="20px" />
          <b class="h5 font-weight-bold ml-2 title">Energy Consumption</b>
        </span>
        <div class="d-block d-md-none text-center" v-if="currentInput >= 0">
          <span onclick="location.href = '/'">
            <i
              style="position: absolute; left: 20px;"
              class="fa fa-long-arrow-left float-left fa-2x"
              aria-hidden="true"
            ></i>
          </span>
          <span>
            <b
              class="text-center"
            >{{ currentHall && currentInput != 0 ? currentHall.sections[currentInput - 1].name : location.name }}</b>
          </span>
          <div class="progress mt-2 mb-2">
            <div
              class="progress-bar bg-dark"
              role="progressbar"
              :style="{ width: ( (currentInput + 1) / 5) * 100   + '%' }"
              aria-valuenow="15"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>
        <div class="row mt-md-5 mb-5">
          <div class="col-md-3 mb-5 d-none d-md-block">
            <ul class="list-group borderless">
              <li
                class="list-group-item"
                v-bind:class="{ 'is-active' : currentInput == 0 ? true : false}"
              >
                <span v-if="currentInput == 0">
                  <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                </span>
                {{ location.name }}
              </li>
              <li
                class="list-group-item"
                v-bind:class="{ 'is-active' : currentInput == 1 ? true : false}"
              >
                <span v-if="currentInput == 1">
                  <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                </span>
                Freezer Equipment
              </li>
              <li
                class="list-group-item"
                v-bind:class="{ 'is-active' : currentInput == 2 ? true : false}"
              >
                <span v-if="currentInput == 2">
                  <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                </span>
                Oxygen Reduction
              </li>
              <li
                class="list-group-item"
                v-bind:class="{ 'is-active' : currentInput == 3 ? true : false}"
              >
                <span v-if="currentInput == 3">
                  <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                </span>
                Conveyer & Crane Equipment
              </li>
              <li
                class="list-group-item"
                v-bind:class="{ 'is-active' : currentInput == 4 ? true : false}"
              >
                <span v-if="currentInput == 4">
                  <i class="fa fa-long-arrow-right" aria-hidden="true"></i>
                </span>
                Office / Other
              </li>
            </ul>
          </div>
          <div class="col-xs-12 col-md-6 text-center align-content-center mt-md-5 px-md-5">
            <div class="row" v-if="currentInput == 0">
              <div class="col-md-6 offset-md-3 text-left mx-auto">
                <span>To get started, please choose your hall.</span>
                <div class="position-relative form-group mt-5 mt-md-0">
                  <select class="form-control hall-select" v-model="currentHall">
                    <option
                      v-for="hall in location.halls"
                      :key="hall.name"
                      :value="hall"
                    >{{ hall.name }}</option>
                  </select>
                  <span class="hall-label">Hall</span>

                  <div class="text-right">
                    <button
                      class="btn mt-4 mt-md-2 continue-btn"
                      type="submit"
                      v-bind:class="{ 'disabled' : currentHall ? false : true }"
                      @click="currentHall ? currentInput = 1 : ''; complete = ''"
                    >Continue</button>
                  </div>
                </div>
              </div>
            </div>

            <div class="row px-md-4" v-if="currentInput > 0">
              <div class="col-md-12 text-left mb-2">Please fill out all current meter readings.</div>
              <div
                class="col-md-6 mb-4 position-relative"
                v-for="(meter, index) in getCurrentSectionMeters()"
                :key="meter.meterId"
              >
                <div class="input-group mb-3 form-label-group">
                  <input
                    type="text"
                    class="form-control border-right-0"
                    :placeholder="'Meter ' + (index + 1)"
                    aria-describedby
                    v-model="tempReadings[index]"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text bg-white border-left-0 rounded">
                      <b>kWh</b>
                    </span>
                  </div>
                  <span class="meter-id">{{ meter.meterId }}</span>
                </div>
              </div>
              <div class="col-md-12 text-right">
                <button
                  v-if="currentInput > 0"
                  class="btn back-btn mr-3 d-none d-md-block float-left"
                  @click="currentInput--; setOldTempValues()"
                >Back</button>
                <button
                  class="btn continue-btn float-right mt-5 mt-md-0"
                  @click="gotoNextSection"
                >{{ currentInput == 4 ? "Submit" : "Continue" }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let data = {
  currentInput: "0",
  currentHall: "",
  tempReadings: [],
  readings: [],
  error: "",
  complete: ""
};

export default {
  name: "EnergyConsumption",
  props: {
    location: Object
  },
  mounted: function() {},
  watch: {
    currentHall: function() {
      this.readings = [];
      this.tempReadings = [];
    }
  },
  methods: {
    gotoNextSection() {
      this.error = "";
      this.complete = "";
      if (this.saveCurrentReadings()) {
        if (this.currentInput < 4) {
          this.tempReadings = [];
          this.currentInput++;
          this.setOldTempValues();
        } else {
          this.currentInput = 0;
          this.complete = "Meter readings saved.";
          this.readings = [];
          this.tempReadings = [];
        }
      }
    },
    setOldTempValues() {
      let that = this;
      let meters = this.getCurrentSectionMeters();
      meters.forEach((meter, index) => {
        let pastReading = that.readings.find(
          reading => reading.id == meter.meterId
        );
        if (pastReading) {
          that.tempReadings[index] = pastReading.units;
        }
      });
    },
    getCurrentSectionMeters() {
      let that = this;
      var section = this.currentHall.sections.filter(function(section) {
        return section.id == that.currentInput;
      });
      return section[0].meters;
    },
    saveCurrentReadings() {
      let that = this;
      let meters = that.getCurrentSectionMeters();

      let success = true;

      if (this.tempReadings.length != meters.length) {
        that.error = "Please fill all the meter readings.";
        document.getElementById("modal-btn").click();
        success = false;
        return;
      }

      this.tempReadings.forEach(function(reading, index) {
        if (reading == undefined || reading == "") {
          that.error = "Please fill all the meter readings.";
          document.getElementById("modal-btn").click();
          success = false;
          return;
        }

        if (isNaN(reading)) {
          that.error = "All readings should be valid numbers.";
          document.getElementById("modal-btn").click();
          success = false;
          return;
        }

        let id = meters[index].meterId;

        that.readings = that.readings.filter(function(reading) {
          return reading.id != id;
        });

        that.readings.push({
          id: id,
          units: reading
        });
      });

      return success;
    }
  },
  data: function() {
    return data;
  }
};
</script>

<style scoped>
.modal-header {
  background: #001d3e;
  height: 60px;
  margin-top: -3px;
}

.borderless li {
  border: none;
  color: #8e9dab;
}
.borderless .is-active {
  font-weight: bold;
  margin-left: -17px;
  color: #001d3e;
}

.form-group {
  height: 3em;
  margin: 1em 0;
  position: relative;
  width: 100%;
}

.form-group input,
.form-group label {
  cursor: text;
  font-size: 1.5em;
  font-weight: 200;
  position: absolute;
  transition: all 0.15s ease;
  width: 100%;
}

.form-group input {
  border: none;
  border-radius: 4px;
  background: #efefef;
  height: 60px;
  padding: 20px 20px 0;
  outline: none;
}

.form-group label {
  color: #9b9b9b;
  font-weight: 400;
  line-height: 60px;
  padding: 0 20px;
  text-transform: uppercase;
}

.form-group input.filled ~ label,
.form-group input:focus ~ label {
  font-size: 0.9em;
  position: absolute;
  margin-top: -12px;
}

.form-group input.filled ~ label {
  /*color: #007932; */
}

.title {
	color: #001D3E;
}

.alert-fixed {
  position: fixed;
  top: calc(50% - 50px);
  left: 25%;
  height: 50px;
  width: 50%;
  z-index: 9999;
  border-radius: 5px;
}

.back-btn {
  background: rgba(201, 170, 56, 0.49);
  border-radius: 10px;
  color: #001d3e;
  padding: 10px 25px;
}

.modal-lg {
  max-width: 50%;
}

.continue-btn {
  background: rgba(0, 119, 190, 0.2);
  border-radius: 10px;
  color: #001d3e;
  padding: 10px 25px;
}

input,
select {
  height: 60px;
  border-radius: 5px;
}

select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding: 25px 0 0 10px;
  text-transform: uppercase;
  font-weight: bolder;
}

.hall-label {
  position: absolute;
  left: 10px;
  top: 5px;
  color: #7a8187;
}

.meter-id {
  color: #ae7919;
  position: absolute;
  right: 0;
  bottom: -25px;
  font-size: 0.9rem;
}

.back-btn, .continue-btn {
	width: 120px;
}

.input-group-append > .input-group-text {
	border-top-left-radius: 0px !important;
	border-bottom-left-radius: 0px !important;
}

input, .input-group-append > span {
	-webkit-transition: all 0ms ease;
	-moz-transition: all 0ms ease;
	-ms-transition: all 0ms ease;
	-o-transition: all 0ms ease;
	transition: all 0ms ease;
}

input:focus, input:focus + .input-group-append > span, .hall-select {
	border-color: #001d3e !important;
	outline: none !important;
	box-shadow: none;
}

input:focus + .input-group-append > span > b {
	color: #001d3e;
}

@media screen and (max-width: 768px) {
  .modal-lg {
    max-width: 100%;
    margin: 0 15px;
  }

  .card {
    height: 85vh;
  }

  .continue-btn {
    width: 100%;
  }

  .alert {
    width: 100%;
    position: relative;
    left: 0;
  }

  .borderless li,
  .d-block.d-md-none.text-center b {
    font-size: 1.3rem;
    margin-bottom: 10px;
  }

  .input-group-append .rounded {
	border-top-left-radius: 0px !important;
	border-top-right-radius: 15px !important;
	border-bottom-left-radius: 0px !important;
	border-bottom-right-radius: 15px !important;
	border-width: 1.5px;
  }

  input,
  select {
	border-radius: 15px;
	border-width: 1.5px;
  }
}

.close {
  opacity: 1;
}
@media screen and (max-width: 359px) {
  .card {
    height: 80vh;
  }
}
</style>